import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;
const VOUCHER_DIST_ENDPOINT = `${REACT_APP_REST_ENDPOINT}/voucher-distribution`;

const VoucherDistributionService = {
    /**
     * Recupera il magazzino voucher del Superpartner loggato.
     */
    getMagazzino(id_superpartner) {
        const url = `${VOUCHER_DIST_ENDPOINT}/get-magazzino`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, {id_superpartner});
        });
    },

    getHistoryForAgenzia(id_agenzia) {
        const url = `${VOUCHER_DIST_ENDPOINT}/history-for-agenzia`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, { id_agenzia });
        });
    },

    /**
     * Esegue la distribuzione di un pacchetto voucher a un'agenzia.
     */
    distribute(data) {
        const url = `${VOUCHER_DIST_ENDPOINT}/distribute`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, data);
        });
    }
};

export default VoucherDistributionService;